<template>
    <div id="how-it-works">
        <!--=====================================-->
        <!--=        How It Works Area Start     =-->
        <!--=====================================-->
        <section class="section section-padding sunflower-line-background ">
            <div class="container">
                <div class="section-heading heading-left">
                    <span class="subtitle primary">¿Cómo funciona?</span>
                    <div class="row">
                        <div class="col-lg-7">
                            <h2 class="font-weight-100">
                                Invierte desde ${{ isMounted ? (rgStats.minimum_investment_amount_MXN || 500) : '--' }} en
                                proyectos que generan un <span class="bold">impacto positivo</span> en el entorno.
                            </h2>
                        </div>
                    </div>
                </div>
                <div class="row mobile-center">
                    <div class="col-lg-4" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">
                        <div class="testimonial-grid">
                            <div class="bullet cursor-icon" :style="`background-image: url(${img1});`"></div>
                            <p class="bold mb-0">1. Crea tu cuenta.</p>
                        </div>
                        <p class="p-width">En 3 minutos podrás empezar a invertir.</p>
                    </div>
                    <div class="col-lg-4" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">
                        <div class="testimonial-grid">
                            <div class="bullet" :style="`background-image: url(${img2});`"></div>
                            <p class="bold mb-0">2. Invierte.</p>
                        </div>
                        <p class="p-width">Impacta al mundo con más inversionistas.</p>
                    </div>
                    <div class="col-lg-4" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300">
                        <div class="testimonial-grid">
                            <div class="bullet" :style="`background-image: url(${img3});`"></div>
                            <p class="bold mb-0">3. Cobra tus intereses.</p>
                        </div>
                        <p class="p-width">Recibe pagos recurrentes para retirar o reinvertir.</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "HowItWorks",
    props: ["rgStats", "isMounted"],
    components: {
    },
    data() {
        return {
            img1: "https://cdn.redgirasol.com/nuevo_portal/icons/cursor-icon.png",
            img2: "https://cdn.redgirasol.com/nuevo_portal/icons/sunflower-icon.png",
            img3: "https://cdn.redgirasol.com/nuevo_portal/icons/coin-icon.png",
        }
    },
}

</script>

<style scoped>
.p-width {
    width: 15rem !important;
}

.bullet {
    background-repeat: no-repeat;
    background-size: 4.5rem;
    /* background-position-x: 1rem; */
}

.bullet.cursor-icon {
    background-size: 3.5rem !important;
    background-position-x: 1rem !important;
}


@media (max-width: 767px) {
    .mobile-center {
        text-align: -webkit-center;
    }
}
</style>